import Card from '../card';
import classNames from 'classnames';

const Preload = ({
    pageIds,
    isContainer,
    isWideFirst
}) => {

    if (!pageIds) {
        return null;
    }

    return (
        <div className="related-content__pages-container">
             <ul className={classNames({
                'related-content__pages': true,
                'related-content__pages--preload': true,
                'related-content__pages--is-wide': isWideFirst
             })}>
                {pageIds.map((page, index) => {
                    return (
                        <li 
                            key={`${page}${index}`}
                            className={classNames({
                                'related-content__page--is-wide': index === 0 && isWideFirst
                            })}>
                            <Card isLoading={true} isContainer={isContainer} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Preload;